import { useEffect, useState } from "react";
import api from "../services/api";

export default function Dashboard() {
  const [users, setUsers] = useState([]);

  useEffect(() => {
    // api.get("/users").then(res => setUsers(res.data));
  }, []);

  return (
    <div className="content">
      <h2>Users</h2>

      <table className="data-table">
        <thead>
          <tr>
            <th>ID</th>
            <th>Email</th>
            <th>Role</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {/* {users.map(u => (
            <tr key={u.id}>
              <td>{u.id}</td>
              <td>{u.email}</td>
              <td>{u.role_id  === 1 ? "Admin" : "Business"}</td>
              <td>{u.status ? "Active" : "Inactive"}</td>
            </tr>
          ))} */}
        </tbody>
      </table>
    </div>
  );
}
